import {useEffect, useState} from 'react'

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const toggle = () => {
    setIsOpen(!isOpen)
  }
  return {
    isOpen,
    toggle
  }
}

export const useModalWithPromise = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [resolver, setResolver] = useState<((value: boolean) => void) | null>(null)

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const open = (): Promise<boolean> => {
    setIsOpen(true)
    return new Promise((resolve) => {
      setResolver(() => resolve)
    })
  }

  const close = (confirmed: boolean) => {
    setIsOpen(false)
    if (resolver) {
      resolver(confirmed)
      setResolver(null)
    }
  }

  return { isOpen, open, close }
}

export const useDoubleModal = () => {
  const [douIsOpen, setDouIsOpen] = useState(false)

  const douToggle = () => {
    setDouIsOpen(!douIsOpen)
  }
  return {
    douIsOpen,
    douToggle
  }
}
